import React from 'react';

/* React functional component */
const HomeScreen: React.FC = () => {
  return <h1>{process.env.REACT_APP_APP_NAME}</h1>;
};

export default HomeScreen;
